import React from 'react';
import VoiceRecorder from './components/VoiceRecorder';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white p-4 md:p-8" data-id="element-0">
      <VoiceRecorder data-id="element-1" />
    </div>;
}